class CancellablePromise extends Promise {
    constructor(executor) {
        super((resolve, reject) => {
            executor((val) => {
                if (this.isCancelled)
                    return;
                resolve(val);
            }, (err) => {
                if (this.isCancelled)
                    return;
                reject(err);
            });
        });
        this._controller = new AbortController();
    }
    get isCancelled() {
        return this._controller.signal.aborted;
    }
    cancel() {
        this._controller.abort();
    }
    static fromPromise(promise) {
        return new CancellablePromise((resolve, reject) => {
            promise.then(resolve).catch(reject);
        });
    }
}

export { CancellablePromise };
